var exports = {
  "D": "x2b2fbebb--cd14ed--title",
  "u": "x2b2fbebb--cd14ed--section",
};

module.exports = exports;
